import {addressList} from './services/address_list';
import {basket} from './services/basket';
import {bookableItem} from './services/bookable_item';
import {bulkPurchase} from './services/bulk_purchase';
import {category} from './services/category';
import {client} from './services/client';
import {clientDetails} from './services/client_details';
import {clinic} from './services/clinic';
import {company} from './services/company';
import {day} from './services/day';
import {deal} from './services/deal';
import {event} from './services/event';
import {eventChain} from './services/event_chain';
import {eventGroup} from './services/event_group';
import {eventSequence} from './services/event_sequence';
import {itemDetails} from './services/item_details';
import {login} from './services/login';
import {member} from './services/member';
import {memberBooking} from './services/member_bookings';
import {memberLogin} from './services/member_login';
import {memberPrePaidBookings} from './services/member_pre_paid_bookings';
import {memberPurchase} from './services/member_purchase';
import {membershipLevels} from './services/membership_levels';
import {multiBasket} from './services/multi_basket';
import {packageItem} from './services/package_item';
import {person} from './services/person';
import {product} from './services/product';
import {purchase} from './services/purchase';
import {purchaseTotal} from './services/purchase_total';
import {reason} from './services/reason';
import {resource} from './services/resource';
import {question} from './services/question';
import {queuer} from './services/queuer';
import {service} from './services/service';
import {slot} from './services/slot';
import {space} from './services/space';
import {sso} from './services/sso';
import {time} from './services/time';
import {timeSlot} from './services/time_slot';
import {wallet} from './services/wallet';

import {adminAddress} from './services/admin_address';
import {adminAdministrator} from './services/admin_administrator';
import {adminBooking} from './services/admin_booking';
import {adminClinic} from './services/admin_clinic';
import {adminCompany} from './services/admin_company';
import {adminDay} from './services/admin_day';
import {adminEventChain} from './services/admin_event_chain';
import {adminEventGroup} from './services/admin_event_group';
import {adminLogin} from './services/admin_login';
import {adminOrder} from './services/admin_order';
import {adminSchedule} from './services/admin_schedule';
import {adminSlot} from './services/admin_slot';
import {adminTime} from './services/admin_time';

const BBService = {
    addressList,
    basket,
    bookableItem,
    bulkPurchase,
    category,
    client,
    clientDetails,
    clinic,
    company,
    day,
    deal,
    event,
    eventChain,
    eventGroup,
    eventSequence,
    itemDetails,
    login,
    member,
    memberBooking,
    memberLogin,
    memberPrePaidBookings,
    memberPurchase,
    membershipLevels,
    multiBasket,
    packageItem,
    person,
    product,
    purchase,
    purchaseTotal,
    reason,
    resource,
    question,
    queuer,
    service,
    slot,
    space,
    sso,
    time,
    timeSlot,
    wallet,

    adminAddress,
    adminAdministrator,
    adminBooking,
    adminClinic,
    adminCompany,
    adminDay,
    adminEventChain,
    adminEventGroup,
    adminLogin,
    adminOrder,
    adminSchedule,
    adminSlot,
    adminTime
};

export {
    BBService
};
